import { ServiceProvider } from 'presentation/app/hooks/useService';
import { FiltersProvider } from 'presentation/app/modules/Dashboard/hooks/useFilters';
import { store } from 'presentation/config/store';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { SkeletonTheme } from 'react-loading-skeleton';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './index.css';
import App from './App';
import { AuthProvider } from './presentation/app/hooks/useAuth';
import { LoadingProvider } from './presentation/app/hooks/useLoading';
import { WebSocketProvider } from './presentation/app/hooks/WebSocketProvider';
import reportWebVitals from './reportWebVitals';

import 'react-loading-skeleton/dist/skeleton.css';
import { PasswordResetFlowProvider } from 'presentation/app/contexts/PasswordResetFlowContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <ServiceProvider>
    <Provider store={store}>
      <PasswordResetFlowProvider>
        <React.Fragment>
          <SkeletonTheme baseColor="#ffffff48" highlightColor="#ffffff6c">
            <BrowserRouter basename={process.env.PUBLIC_URL}>
              <FiltersProvider>
                <AuthProvider>
                  <LoadingProvider>
                    <WebSocketProvider>
                      <App />
                    </WebSocketProvider>
                  </LoadingProvider>
                </AuthProvider>
              </FiltersProvider>
            </BrowserRouter>
          </SkeletonTheme>
        </React.Fragment>
      </PasswordResetFlowProvider>
    </Provider>
  </ServiceProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
